import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, search, state } = useLocation();

  useEffect(() => {
    // Front Desk week navigation is an in-place schedule control, not a new
    // page. It preserves the schedule anchor and focus itself; do not override
    // that with the global route-change reset when only its week query changes.
    if (pathname === '/staff/frontdesk' && state?.preserveScroll === 'frontdesk-schedule') return;
    window.scrollTo(0, 0);
  }, [pathname, search, state]);

  return null;
}
